<template>
  <footer class="mt-auto footer primary">
    <div class="pb-5">
      <v-container>
        <v-row justify="center" justify-lg="space-around">
          <v-col
            class="px-10 px-md-0 px-lg-0 pt-4 pt-md-6 pt-lg-8"
            cols="8"
            sm="5"
            md="3"
            lg="3"
          >
            <img height="62px" :src="files + informations.img" alt="Logo" />
          </v-col>
          <v-col
            class="pt-4 pt-md-6 pt-lg-8 d-lg-flex justify-center"
            cols="12"
            md="5"
            lg="5"
            v-if="socialContats"
          >
            <div class="d-flex justify-center flex-column">
              <div
                class="footer-title white--text text-uppercase mb-2 font-italic"
              >
                Fale Conosco
              </div>
              <div
                class="opens-sans mb-4"
                v-for="({ title, tel, whatsapp }, key) in socialContats"
                :key="key"
              >
                <div class="white--text">{{ title }}</div>

                <div class="white--text d-flex flex-wrap">
                  <div v-if="tel" class="mr-5 mb-2">
                    <v-icon class="mr-2" color="white" size="18"
                      >fas fa-phone-alt</v-icon
                    >
                    <a
                      target="_self"
                      class="white--text text-decoration-none font-weight-bold"
                      :href="getTelLinkFromPhone(tel)"
                      >{{ tel }}</a
                    >
                  </div>
                  <div
                    v-for="(
                      { phone, label, whatsappLink }, i
                    ) in getStoreWhatsappContacts({
                      title,
                      whatsapp,
                    })"
                    :key="`${title}-${phone}-${i}`"
                    class="mr-5 mb-2"
                  >
                    <v-icon class="mr-2" size="20" color="white"
                      >fab fa-whatsapp</v-icon
                    >
                    <a
                      target="_blank"
                      class="white--text text-decoration-none font-weight-bold"
                      :href="whatsappLink"
                      >{{ label }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col
            class="pt-4 pt-md-6 pt-lg-8 d-flex justify-md-center"
            cols="12"
            md="4"
            lg="4"
          >
            <div class="d-flex flex-column">
              <div
                class="white--text text-uppercase footer-title mb-2 font-italic"
              >
                Nos siga nas redes sociais
              </div>
              <div class="d-flex" v-if="socialFooter">
                <div
                  class="d-flex align-center item"
                  v-for="({ link, target, icon }, key) in socialFooter"
                  :key="key"
                >
                  <v-btn
                    :href="link"
                    :target="target"
                    rounded
                    text
                    icon
                    class="d-flex text-decoration-none social-footer-icon mr-3"
                  >
                    <v-icon size="20" color="primary">
                      {{ icon }}
                    </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-sheet color="primary" width="100%" class="d-flex align-center">
      <v-container class="border">
        <div
          class="
            opens-sans
            d-flex
            align-center
            justify-center justify-lg-space-between
            flex-column flex-lg-row
          "
        >
          <div class="white--text text-center my-3 my-lg-5 copyright">
            {{ `Copyright © ` }}
            <span class="font-weight-bold"
              >{{ year }} {{ informations.name }}.</span
            >
            Todos os direitos reservados.
          </div>

          <a href="https://mrxweb.com.br/" target="_blank" class="my-3 my-lg-5">
            <img
              class="d-block"
              src="/img/mrx.svg"
              height="20px"
              alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
              title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            />
          </a>
        </div>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getSocial } from "../../config";
import { getTelLinkFromPhone } from "../../utils/getTelLinkFromPhone";
import { getStoreWhatsappContacts } from "../../utils/storeWhatsappContacts";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    socialContats() {
      return this.$rest(`stores`).list;
    },
    socialFooter() {
      return getSocial(this);
    },
    informations() {
      return this.$rest(`informations`).item;
    },
    social() {
      return this.$rest(`social`).item;
    },
  },
  methods: {
    getTelLinkFromPhone,
    getStoreWhatsappContacts,
  },
};
</script>

<style lang="scss" scoped>
.social-footer-icon {
  background-color: #c9cdcf;
}
.footer-title {
  font-weight: 500 !important;
  letter-spacing: 1px;
  font-size: 28px;
  font-family: "PF Din Text Comp Pro" !important;
}
.opens-sans {
  font-family: "Open Sans", sans-serif;
}
.footer {
  padding-bottom: 83px;
  .btn-info {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
.border {
  border-top: 2px solid rgb(255, 255, 255, 0.15);
  padding: 0 !important;
}

.item:nth-child(4) .word-break {
  word-break: break-all !important;
}
</style>
